import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dutchDateTime',
  standalone: true, 
  pure: true
})
export class DutchDateTimePipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (!value) return '';

    const date = new Date(value);

    return date.toLocaleString('nl-NL', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}